<p-dialog
    [modal]="true"
    [maximizable]="true"
    [header]="'Enviar de Arquivo'"
    [(visible)]="modalVisible"
    (onHide)="fecharModal()"
    styleClass="w-150 max-w-[90%]"
>
    <div class="w-full flex flex-col gap-4 p-4">
        <!-- <app-input
            [(ngModel)]="senha"
            label="Senha do Certificado"
            type="password"
        ></app-input> -->

        <p-fileUpload
            #uploadInput
            mode="basic"
            maxFileSize="10000000000000000000000000000000000"
            (onSelect)="uploadArquivoExe($event)"
            [chooseLabel]="'Selecione o Arquivo'"
        ></p-fileUpload>

        <app-footer-page
            [end]="true"
            (cancelar)="fecharModal()"
            (confirmar)="enviar()"
            labelConfirmar="Enviar"
        >
        </app-footer-page>
    </div>

    @if (exibirLoader | async) {
        <div
            style="
                position: fixed;
                width: 44vw;
                height: 43vh;
                top: 0;
                left: 0;
                z-index: 100;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(255, 255, 255, 0.4);
            "
        >
            <p-progressSpinner></p-progressSpinner>
        </div>
    }

    @if (exibirLoaderNetwork | async) {
        <div
            style="
                position: fixed;
                width: 44vw;
                height: 43vh;
                top: 0;
                left: 0;
                z-index: 100;
                display: flex;
                align-items: center;
                justify-content: center;
                background-color: rgba(255, 255, 255, 0.4);
            "
        >
            <p-progressSpinner></p-progressSpinner>
        </div>
    }
</p-dialog>
